<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M11.2929 10.7071C11.6834 11.0976 12.3166 11.0976 12.7071 10.7071C13.0976 10.3166 13.0976 9.68342 12.7071 9.29289L11.2929 10.7071ZM8 6L8.70711 5.29289C8.31658 4.90237 7.68342 4.90237 7.29289 5.29289L8 6ZM3.29289 9.29289C2.90237 9.68342 2.90237 10.3166 3.29289 10.7071C3.68342 11.0976 4.31658 11.0976 4.70711 10.7071L3.29289 9.29289ZM12.7071 9.29289L8.70711 5.29289L7.29289 6.70711L11.2929 10.7071L12.7071 9.29289ZM7.29289 5.29289L3.29289 9.29289L4.70711 10.7071L8.70711 6.70711L7.29289 5.29289Z"
    fill="currentColor"
  />
</svg>
